import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const FeaturedPostsBase = styled.div`
  margin: 40px 0 0 0;
`;

export const LargePostAndRecentStories = styled.div`
  display: flex;
  flex-direction: row;
`;

export const LargePostContainer = styled.div`
  flex: 1 0 75%;
  height: 343px;
  display: flex;
  flex-direction: column;

  ${theme.largerThan.md} {
    height: 566px;
  }
`;

export const RecentStoriesSection = styled.div`
  flex: 1 0 25%;
  display: none;

  ${theme.largerThan.md} {
    display: initial;
  }
`;

export const RecentStoriesContent = styled.div`
  margin-left: 24px;
  height: 100%;
`;

export const RecentStories = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
`;

export const RecentStoriesTitle = styled.div`
  color: ${theme.colors.darkBlues[75]};
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 12px;
`;

export const RecentStory = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 auto;
  border-bottom: 1px solid ${theme.colors.darkBlues[25]};
  padding: 16px 0;

  &:first-of-type {
    padding: 0 0 16px 0 !important;
  }

  &:last-of-type {
    border-bottom: initial;
  }
`;

export const RecentStoryLink = styled.a`
  color: ${theme.colors.darkBlues[90]};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  &:hover {
    text-decoration: underline;
  }
`;

export const SmallPostCards = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0 0 0;

  ${theme.largerThan.sm} {
    flex-direction: row;
    margin: 60px 0 0 0;
  }
`;

export const SmallPostCardContainer = styled.div`
  flex: 1 0 0;
  margin: 24px 0 0 0;

  &:first-of-type {
    margin: 0;
  }

  height: 271px;

  ${theme.largerThan.sm} {
    margin: 0 24px 0 0;
    height: 357px;

    &:first-of-type {
      margin: 0 24px 0 0;
    }

    &:last-of-type {
      margin: 0;
    }
  }
`;
